export default __webpack_public_path__ + "static/media/eng.9931805a.svg";